import _ from 'lodash';
import shuffleSeed from 'shuffle-seed';
import PropTypes from 'prop-types';
import { cmsService } from '../services/homii-services';
import useResponsive from '../../utils/responsive';
import HeroSection from '../components/live-page-components/hero-section.component';
import AboutSection from '../components/about-page-components/about-section';
import VideoSection from '../components/live-page-components/video-section.component';
import ReviewSection from '../components/find-a-space-components/review-section.component';
import MobileAppSection from '../components/home-page-components/mobile-app-section.component';

import { Layout, Footer, MetaData } from '../components/shared';

import GalleryCarousel from '../components/gallery/gallery-carousel.component';
import GalleryCarouselMobile from '../components/gallery/gallery-carousel-mobile.component';

const SEED = 'HOMiiVal';

const About = (props) => {
    
    const { data, baseUrlApp, gallery } = props;
    const { isMobile } = useResponsive();
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroParagraph = _.get(data, 'acf.hero_paragraph');
    const heroSubHeading = _.get(data, 'acf.hero_sub_heading');
    const heroImage = _.get(data, 'acf.hero_main_image');
    const heroImageAlt = _.get(data, 'acf.hero_main_image_alt');
    const videoUrl = _.get(data, 'acf.video_url');
    const aboutTitle = _.get(data, 'acf.about_section_title');
    const aboutImage = _.get(data, 'acf.about_section_image.url');
    const aboutImageAlt = _.get(data, 'acf.about_section_image_alt');
    const aboutIcons = _.get(data, 'acf.about_section_icons');
    const reviews = _.get(data, 'acf.review');
    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');
    const media = _.get(gallery, 'acf.items');

    return (

        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} canonical={`${baseUrlApp}/about`} />

            <div>

                <div className='corporate-container'>

                    <HeroSection
                        negativeMargin
                        title={heroTitle}
                        paragraph={heroParagraph}
                        subheading={heroSubHeading}
                        imgSrc={heroImage}
                        imgAlt={heroImageAlt}
                        id="about_header"
                    />

                </div>

                <AboutSection
                    title={aboutTitle}
                    imgSrc={aboutImage}
                    imgAlt={aboutImageAlt}
                    icons={aboutIcons}
                />

                <VideoSection
                    videoUrl={videoUrl}                    
                    marginTop={130}
                    marginBottom={150}
                    marginTopMobile={50}
                    marginBottomMobile={70}
                />

                {isMobile ? 
                    <div className='carousel-container-mobile'>
                        <GalleryCarouselMobile category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                    </div>
                    :
                    <div className='container-root container-root-maxWidthLg blog-carousel-container building-carousel-container-settings'>
                        <div style={{ marginBottom: 183 }}> 
                            <GalleryCarousel category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                        </div>
                    </div>
                }

                <ReviewSection reviews={reviews} />

               <div className='corporate-container'>

                    <MobileAppSection                        
                        title={mobileAppTitle}
                        paragraph={mobileAppParagraph}
                        icon={mobileAppIcon}
                        iconText={mobileAppIconText}
                        primaryImgSrc={mobilePrimaryImgSrc}
                        primaryImgAlt={mobilePrimaryImgAlt}
                        secondaryImgSrc={mobileAppSecondaryImgSrc}
                        secondaryImgAlt={mobileAppSecondaryImgAlt}
                    />

                </div>

            </div>

            <Footer />

        </Layout>
    );
};

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('about');
    const respGallery = await cmsService.RetrieveWordPressPage('gallery'); 
    return {
        props: {
            data: resp,
            gallery: respGallery
        }
    };
};

export default About;

About.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
    gallery: PropTypes.object,
};


